"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Report_1 = require("./Report");
exports.default = Report_1.Report;
